import { getPhoneEntries, getSocialMedia, ensureUrl } from './profileData';

/**
 * Builds a vCard 3.0 string (same fields as admin portal preview).
 */
export function generateVCardString(profileData, profilePageUrl = '') {
  if (!profileData) return '';

  const { cardInfo = {}, personalInfo = {} } = profileData;
  const social = getSocialMedia(profileData);

  const firstName = personalInfo.firstname || '';
  const lastName = personalInfo.lastname || '';
  const fullName =
    `${firstName} ${lastName}`.trim() || cardInfo.card_name || '';
  const email = personalInfo.email || '';
  const company = personalInfo.company || '';
  const occupation = cardInfo.occupation || '';
  const address = personalInfo.location || '';
  const website = social.website ? ensureUrl(social.website) : '';

  const phoneEntries = getPhoneEntries(profileData);
  const phoneLines = phoneEntries.map((entry, index) => {
    const phone = profileData.phoneNumbers?.[index];
    const type = entry.phoneType || phone?.phone_type || 'voice';
    let vcardType = 'VOICE';
    if (type === 'mobile' || type === 'cell') vcardType = 'CELL';
    else if (type === 'work') vcardType = 'WORK';
    else if (type === 'home') vcardType = 'HOME';
    else if (type === 'fax') vcardType = 'FAX';

    const pref = entry.isPrimary || phone?.is_primary ? ';PREF=1' : '';
    return `TEL;TYPE=${vcardType}${pref}:${entry.number}`;
  });

  let vcard = 'BEGIN:VCARD\nVERSION:3.0\n';
  vcard += `FN:${fullName}\n`;
  vcard += `N:${lastName};${firstName};;;\n`;
  if (email) vcard += `EMAIL:${email}\n`;
  if (company) vcard += `ORG:${company}\n`;
  if (occupation) vcard += `TITLE:${occupation}\n`;
  if (address) vcard += `ADR:;;${address};;;;\n`;
  if (website) vcard += `URL;TYPE=URL:${website}\n`;
  if (profilePageUrl) vcard += `URL:${profilePageUrl}\n`;

  phoneLines.forEach((line) => {
    vcard += `${line}\n`;
  });

  vcard += 'END:VCARD';
  return vcard;
}

export function downloadVCard(profileData, profilePageUrl = '') {
  const vcardString = generateVCardString(profileData, profilePageUrl);
  if (!vcardString) return false;

  const blob = new Blob([vcardString], { type: 'text/vcard;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  const safeFileName = (
    profileData?.cardInfo?.card_name ||
    profileData?.personalInfo?.firstname ||
    'contact'
  ).replace(/[^a-z0-9]/gi, '_');
  link.download = `${safeFileName}.vcf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
  return true;
}
